import { HttpService } from "@/core";
import { TabsType } from "./flow-status-tabs.interface";
export const post = () => {
  const api = (url, data: any = {}) =>
    HttpService.axios({
      method: "POST",
      url,
      data,
    });
  return HttpService.useRequest<any>(api);
};
export const get = () => {
  const api = (url, params: any = {}) =>
    HttpService.axios({
      method: "GET",
      url,
      params,
    });
  return HttpService.useRequest<any>(api);
};
export const getCount = () => {
  const api = (bizType, params: any = {}) =>
    HttpService.axios({
      method: "GET",
      url:`/common_api/flowStatusAndHszCountByBizType/${bizType}`,
      params,
    });
  return  HttpService.useRequest<{countResp:Array<TabsType>}>(api);
};